import { ITSImage } from "../itsImage.model"

export class PremiumSectionItem {
    constructor(
        public url: string,
        public image: ITSImage,
        public title: string,
        public imageAlt: string
    ) {}

    public static fromData(data) {
        return new PremiumSectionItem(
            data.url,
            new ITSImage(data.image, data.title),
            data.title,
            data.image_alt
        )
    }
}
